
const AvatarInParts = ({parts}) => { 
    return (
            <>
        {parts &&
            <div className='avatar' style={{ display: 'inline-block' }}>
                  <div
                    className='face'
                    style={{
                      backgroundImage: `url(${parts["face_url"]})`,
                    }}
                  />
                  <div className='eye-brow eye-brow-left'>
                    <div
                      className='brow'
                      style={{
                        backgroundImage: `url(${parts["brows_url"]})`,
                      }}
                    />
                    <div
                      className='eye'
                      style={{
                        backgroundImage: `url(${parts["eyes_url"]})`,
                      }}
                    />
                  </div>
                  <div className='eye-brow eye-brow-right'>
                    <div
                      className='brow'
                      style={{
                        backgroundImage: `url(${parts["brows_url"]})`,
                      }}
                    />
                    <div
                      className='eye'
                      style={{
                        backgroundImage: `url(${parts["eyes_url"]})`,
                      }}
                    />
                  </div>
                  <div
                    className='nose'
                    style={{
                      backgroundImage: `url(${parts["nose_url"]})`,
                    }}
                  />
                  <div
                    className='lips'
                    style={{
                      backgroundImage: `url(${parts["lips_url"]})`,
                    }}
                  />
                </div>} </>
    )
}

export default AvatarInParts
